<template>
    <span 
      class="button-back touch"
      :class="{ 'button-back--disable': isTopLevelNav }"
      @click="handleBack"
    >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
      <path
        d="M18.2 273l-17-17 17-17L171.8 85.4l17-17 33.9 33.9-17 17L93.1 232 424 232l24 0 0 48-24 0L93.1 280 205.8 392.6l17 17-33.9 33.9-17-17L18.2 273z"
      />
    </svg>
    <div>{{ labels.back[language.code] || labels.back['en'] }}</div>
  </span>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ... mapState({
      labels: 'labels'
    }),

    ...mapGetters({
      language: 'language',
    }),

    isTopLevelNav () {
      let isTopLevelNav = false
      if (this.$route.name === 'living-entry') isTopLevelNav = true
      this.$store.getters.activeBottomBar.forEach(item => {
        if (item.pageId === this.$route.params.pageId) isTopLevelNav = true
      })
      return isTopLevelNav
    },

    isSubLevelNav () {
      let isSubLevelNav = false
      if (this.$store.getters.activeSubBottomBar) {
        this.$store.getters.activeSubBottomBar.forEach(item => {
          if (item.pageId === this.$route.params.pageId) isSubLevelNav = true
        })
      }
      return isSubLevelNav
    }
  },

  methods: {
    handleBack() {
      if (this.isTopLevelNav) return
      if (this.isSubLevelNav) {
        this.$store.getters.activeBottomBar.forEach(item => {
          item.children.forEach(child => {
            if (child.pageId === this.$route.params.pageId) {
              this.$router.push(`/category/${this.$route.params.categoryId}/page/${item.pageId}`)
            }
          })
        })
      } else if (this.$route.name === 'living-option') {
        this.$router.push(`/category/${this.$route.params.categoryId}/live/masterplan`)
      } else if (this.$route.name === 'subsection') {
        if (this.$store.getters['property/activeSubsection'].parent.type === 'livingOption') {
          const parentLivingOption = this.$store.state.property.livingOptions.find(livingOption => livingOption._id === this.$route.params.livingOptionId)
          if (parentLivingOption.subsectionIds.length === 1) {
            this.$router.push(`/category/${this.$route.params.categoryId}/live/masterplan`)
          } else {
            this.$router.push(`/category/${this.$route.params.categoryId}/live/masterplan/${this.$route.params.livingOptionId}`)
          }
        } else if (this.$store.getters['property/activeSubsection'].parent.type === 'subsection') {
          this.$router.push(`/category/${this.$route.params.categoryId}/live/masterplan/${this.$route.params.livingOptionId}/subsection/${this.$store.getters['property/activeSubsection'].parent.id}`)
        } else {
          this.$router.go(-1)
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss">
  .button-back {
    align-items: center;
    background: transparent;
    border: #fff solid 0.1rem;
    border-radius: 0.5rem;
    color: white;
    display: flex;
    gap: 0.95rem;
    height: 3.6rem;
    padding: 0 1rem;
    width: 7.5rem;
    text-transform: uppercase;

    &--disable {
      pointer-events: none;
      opacity: 0.2;
    }

    svg {
      height: 1.2rem;
      fill: #fff;
    }

    div {
      color: #fff;
      font-family: var(--font-family);
      font-size: 1rem;
      // font-weight: 700;
      text-transform: uppercase;
    }
  }
</style>